<template>

    <div class="page">

        <div v-if="!error" class="stats-container">

            <div v-if="loading" class="loading">

                <lottie-loader></lottie-loader>

            </div>

            <article v-else class="stats">

                <header v-if="$mq !== 'lg'" class="stats__header">

                    <h1 class="cf-title-3">{{ $t('statistics_page_name') }}</h1>

                    <a class="stats__header-share" @click="share">{{ $t('menu_share') }}</a>

                </header>

                <main class="stats__main">

                    <stories :type="'carousel'" class="stats__stories"></stories>

                    <section class="stats__section-data">

                        <div class="list">

                            <div class="list__row">

                                <transition name="blociscomming">

                                    <div v-if="showNewsletters || $mq === 'lg'"
                                         :class="{ 'desktop-animation-show': showNewsletters }"
                                         class="list__bloc list__bloc-newsletters desktop-hidden">

                                        <div class="list__top-container">

                                            <img class="stats__icone" src="/img/icons/auto-delete-white.svg">

                                            <output class="cf-title-2">{{ incrementData(blocked) }}</output>

                                        </div>

                                        <span class="list__details">{{ $tc('statistics_autodelete', deleted) | capitalizeFirstLetter }}</span>

                                    </div>

                                </transition>

                                <transition name="blociscomming">

                                    <div v-if="showDeleted || $mq === 'lg'"
                                         :class="{ 'desktop-animation-show': showDeleted }"
                                         class="list__bloc list__bloc-email desktop-hidden">

                                        <div class="list__top-container">

                                            <img class="stats__icone" src="/img/icons/delete-white.svg">

                                            <output class="cf-title-2">{{ incrementData(deleted) }}</output>

                                        </div>

                                        <span class="list__details">{{ $tc('statistics_deleted', deleted) | capitalizeFirstLetter }}</span>

                                    </div>

                                </transition>

                            </div>

                            <div class="list__row">

                                <transition name="blociscomming">

                                    <div v-if="showCo2 || $mq === 'lg'"
                                         :class="{ 'desktop-animation-show': showCo2 }" class="list__bloc list__bloc-carbon desktop-hidden">

                                        <div class="list__top-container">

                                            <img class="stats__icone" src="/img/icons/saved-white.svg">

                                            <output class="cf-title-2">{{ incrementData(subscriptionsCo2, true) }} kg
                                            </output>

                                        </div>

                                        <span class="list__details">{{ $tc('statistics_carbon_saved', pluralCo2) | capitalizeFirstLetter }}</span>

                                    </div>

                                </transition>

                                <transition name="blociscomming">

                                    <div v-if="showAddMailbox || $mq === 'lg'" :class="{ 'desktop-animation-show': showAddMailbox }"
                                         class="list__bloc list__bloc-add-mailbox desktop-hidden"
                                         @click="addMailbox">

                                        <img class="stats__icone" src="/img/icons/plus-blue.svg">

                                        <span class="list__add-mailbox-text">{{ $t('statistics_add_mailbox') }}</span>

                                    </div>

                                </transition>

                            </div>

                        </div>

                    </section>

                    <transition name="blociscomming">

                        <section v-if="showShareCleanfox || $mq === 'lg'"
                                 :class="{ 'desktop-animation-show': showShareCleanfox }"
                                 class="stats__section desktop-hidden stats__section-sponsorship">

                            <h2 class="cf-title-2 stats__section-title">{{ $t('statistics_referral_title') }}</h2>

                            <p class="stats__section-text">{{ $t('statistics_referral_description') }}</p>


                            <div v-if="codeGenerating" class="stats__sponsorship-bloc-cta">

                                <button class="stats__sponsorship-code-generating">{{
                                        $t('statistics_referral_cta_generating')
                                    }}
                                </button>

                                <lottie-loader :size="16"></lottie-loader>

                            </div>

                            <div v-if="!codeGenerating" class="stats__sponsorship-bloc-cta" @click="goForest">

                                <button class="stats__sponsorship-cta pointer">{{
                                        $t('statistics_referral_cta_referral')
                                    }}
                                </button>

                                <img class="stats__sponsorship-arrow pointer" src="/img/icons/arrow-right-blue.svg">

                            </div>

                        </section>

                    </transition>

                    <transition name="blociscomming">

                        <section v-if="showPurchases || $mq === 'lg'" :class="{ 'desktop-animation-show': showPurchases }"
                                 class="stats__section desktop-hidden">

                            <h2 class="cf-title-2 stats__section-title">{{ $tc('statistics_purchase', 2) }}</h2>

                            <markdown :text="$t('statistics_info_carbon')" class="stats__section-text"></markdown>

                            <div class="aside">

                                <aside class="aside__bloc">

                                    <div class="aside__bloc-top">

                                        <img class="stats__icone" src="/img/icons/truck-blue.svg">

                                        <data :value="stats.orders.count" class="aside__value">{{
                                                incrementData(count)
                                            }}
                                        </data>

                                    </div>

                                    <p class="aside__text">{{ $tc('statistics_purchase', count) }}</p>

                                </aside>

                                <aside class="aside__bloc">

                                    <div class="aside__bloc-top">

                                        <img class="stats__icone" src="/img/icons/cloud-emplty-blue.svg">

                                        <data :value="stats.orders.co2" class="aside__value">{{
                                                incrementData(ordersCo2,
                                                    true)
                                            }}
                                        </data>

                                    </div>

                                    <p class="aside__text">{{ $t('statistics_kg') }}</p>

                                </aside>

                            </div>

                        </section>

                    </transition>

                </main>

                <footer class="stats__footer">

                    <img v-if="$mq !== 'lg' && showFoxy" class="stats__foxy" src="/img/foxy/chest.png">

                </footer>

            </article>

            <modal-share ref="MS"></modal-share>


        </div>

        <empty-page v-else></empty-page>

        <tab-bar></tab-bar>

    </div>

</template>

<script>

import Vuex from 'vuex'

import LottieLoader from '@/components/lottie/LottieLoader'
import ModalShare from '@/components/modal/ModalShare'
import Tag from '@/modules/tag'
import UserFlow from '@/modules/userFlow'

import EmptyPage from '@/components/EmptyPage'
import Markdown from '@/components/Markdown'
import Stories from '@/components/stories/Stories.vue'
import TabBar from '@/components/TabBar'

export default {

    name: 'stats',

    components: {EmptyPage, LottieLoader, ModalShare, Markdown, Stories, TabBar},

    watch: {

        subscriptionsCo2: function () {
            this.pluralCo2 = Math.floor(this.subscriptionsCo2)
        },

        percent: function (value) {
            if (value >= 100) {
                this.stopIncrement()
            }
        }

    },

    data() {
        return {
            stats: {
                orders: {co2: 0, count: 0},
                subscriptions: {blocked: 0, co2: 0, deleted: {doing: 0, done: 0}, worst: []}
            },
            blocked: 0,
            deleted: 0,
            subscriptionsCo2: 0,
            count: 0,
            ordersCo2: 0,
            loading: true,
            showNewsletters: false,
            showDeleted: false,
            showCo2: false,
            showAddMailbox: false,
            showShareCleanfox: false,
            showPurchases: false,
            showFoxy: false,
            error: false,
            pluralCo2: 0,
            codeGenerating: true,
            timeToIncrement: 5,
            percent: 0,
            incrementInterval: null
        }
    },

    created() {

        UserFlow.setPage(this, 'stats')
        Tag.pageViewGA(this, 'stats')
    },

    mounted() {

        this.getStatsAsync()
            .then(stats => {
                this.loading = false
                this.showAllBlocs()
                this.fillData(stats)
            })
            .catch(() => {
                this.error = true
            })

        this.refreshUser()
            .then(user => {

                if (user.partnerCode) {

                    this.codeGenerating = false

                }
            })
    },

    methods: {

        ...Vuex.mapActions([
            'getStatsAsync',
            'refreshUser'
        ]),

        showAllBlocs() {

            const self = this
            setTimeout(function () {
                self.showNewsletters = true
            }, 50)
            setTimeout(function () {
                self.showDeleted = true
            }, 100)
            setTimeout(function () {
                self.showCo2 = true
            }, 150)
            setTimeout(function () {
                self.showAddMailbox = true
            }, 200)
            setTimeout(function () {
                self.showShareCleanfox = true
            }, 250)
            setTimeout(function () {
                self.showPurchases = true
            }, 300)
        },

        fillData(stats) {

            if (stats.subscriptions) {

                const self = this
                setTimeout(function () {
                    self.blocked = stats.subscriptions.blocked
                    self.subscriptionsCo2 = (stats.subscriptions.co2 / 1000).toFixed(2)
                    self.deleted = stats.subscriptions.deleted.doing + stats.subscriptions.deleted.done
                    self.count = stats.orders.count
                    self.ordersCo2 = (stats.orders.co2 / 1000).toFixed(2)
                    self.showFoxy = true
                    self.startIncrement()
                }, 500)
            }
        },

        goForest() {

            this.$router.push({path: '/weforest'})

        },

        incrementData(data, toFixed = false) {

            if (this.percent) {
                const value = data / 100 * this.percent
                return toFixed ? Number.parseFloat(value).toFixed(2) : Math.floor(value)
            }
            return 0
        },

        startIncrement() {

            const self = this

            this.incrementInterval = setInterval(function () {

                if (self.percent < 100) {

                    self.percent = self.percent + 1

                }
            }, self.timeToIncrement)
        },

        stopIncrement() {

            clearInterval(this.incrementInterval)
        },

        share() {

            Tag.clickGA(this, 'sharing_toolbar')
            this.$refs.MS.open()

        },

        addMailbox() {
            this.$router.push({path: '/add-inbox'})
        },

        actualize() {

            window.location.reload()

        }

    },

    destroyed() {

        clearInterval(this.interval)
    }

}
</script>

<style lang="scss" scoped>

.page {
    display: flex;
    flex-grow: 1;
}

.stats-container {
    display: flex;
    flex-grow: 1;
    @media screen and (min-width: $above-tablet-length) {
        align-items: center;
        justify-content: center;
        background-image: url(/img/background/cards-desktop.svg);
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: cover;
        background-blend-mode: luminosity;
        background-color: $timberwolf;
        flex-direction: column;
    }
}

.loading {

    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    background-color: $timberwolf;
    @media screen and (min-width: $above-tablet-length) {
        background-color: transparent;
    }
}

.stats {
    width: 100%;
    background-color: $timberwolf;
    padding: 24px 16px 206px;
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: flex-start;
    @media screen and (min-width: $above-tablet-length) {
        width: 480px;
        background-color: transparent;
        padding: 0;
        justify-content: center;
    }

    &__header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    &__stories {
        overflow: scroll;
    }

    &__header-share {
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
        color: $aquamarine;
        cursor: pointer;
    }

    &__main {
        margin-top: 24px;
        display: flex;
        flex-direction: column;
    }

    &__section {
        padding: 24px;
        background-color: $white;
        border-radius: 8px;
        margin-top: 24px;
        text-align: left;
        @media screen and (min-width: $above-tablet-length) {
            padding: 32px;
            margin-top: 16px;
        }
    }

    &__section-sponsorship {
        background-image: url('/img/background/sponsorship-wood.svg');
        background-repeat: no-repeat;
        background-position-x: right;
        background-position-y: bottom;
        background-size: 62px;
    }

    &__section-title {
        margin: 0;
    }

    &__section-text {
        font-size: 17px;
        line-height: 1.29;
        color: $midnight;
        margin: 8px 0 16px;
    }

    &__icone {
        width: 24px;
        object-fit: contain;
    }

    &__footer {
        display: flex;
        align-items: center;
        height: 1px;
        justify-content: center;
    }

    &__foxy {
        position: absolute;
        bottom: 0;
        height: 118px;
        object-fit: contain;
        margin-bottom: 55px;
    }

    &__sponsorship-bloc-cta {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }

    &__sponsorship-code-generating {
        padding: 0;
        margin-right: 7px;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.31;
        color: $stone;
        background-color: white;
    }

    &__sponsorship-cta {
        font-size: 16px;
        font-weight: bold;
        line-height: 1.31;
        color: $aquamarine;
        background-color: $white;
        padding: 0;
    }

    &__sponsorship-arrow {
        width: 24px;
        object-fit: contain;
    }
}

.list {
    display: flex;
    flex-direction: column;

    & .list__row:first-child {
        margin-bottom: 8px;
    }

    & .list__row:last-child {
        margin-top: 8px;
    }

    &__row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    &__bloc {
        margin: 0;
        padding: 12px;
        border-radius: 8px;
        height: 92px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        color: $white;
        flex: 1;
    }

    &__bloc-newsletters {
        background-color: $raspberry;
        margin-right: 16px;
    }

    &__bloc-email {
        background-color: $sunset;
    }

    &__bloc-carbon {
        background-color: $blue;
        margin-right: 16px;
    }

    &__bloc-add-mailbox {
        background-color: $white;
        align-items: center;
        cursor: pointer;
    }

    &__top-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    &__details {
        font-size: 15px;
        font-weight: bold;
        text-align: left;
    }

    &__add-mailbox-text {
        font-size: 15px;
        font-weight: bold;
        color: $blue;
        max-width: 124px;
        @media screen and (min-width: $above-tablet-length) {
            max-width: 200px;
        }
    }

}

.dissmiss-element {
    visibility: hidden;
}

div .list-row:nth-child(even) {
    margin-top: 8px;
}

.aside {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    &__bloc {
        border-radius: 8px;
        background-color: $timberwolf;
        padding: 12px 12px 10px;
        height: 78px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
    }

    &__bloc-top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    &__value {
        font-size: 22px;
        font-weight: bold;
        line-height: 1.27;
        color: $midnight;
    }

    &__text {
        font-size: 15px;
        font-weight: 500;
        line-height: 1.33;
        color: $midnight;
    }

    & aside:nth-child(odd) {
        margin-right: 8px;
    }

    & aside:nth-child(even) {
        margin-left: 8px;
    }

}

/*animation*/

.desktop-hidden {
    @media screen and (min-width: $above-tablet-length) {
        opacity: 0;
    }
}

.blociscomming-enter-active {
    transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.blociscomming-enter {
    transform: translate(0, 50px);
    opacity: 0;
}

.desktop-animation-show {
    @media screen and (min-width: $above-tablet-length) {
        animation: animdesktopshow 200ms ease-in-out 50ms 1 normal forwards;
    }
}

@keyframes animdesktopshow {

    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

</style>
